import script from "./ReportDownloader.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReportDownloader.vue?vue&type=script&lang=ts&setup=true"

import "./ReportDownloader.vue?vue&type=style&index=0&id=712d013d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-712d013d"]])

export default __exports__